import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import hooks from '@g4/automation-hooks';

export class Text extends PureComponent {
  static propTypes = {
    /** Font size (pixels) */
    size: PropTypes.number,
    /** Applies a specified text color */
    color: PropTypes.string,
    /** Applies a specified font-weight */
    weight: PropTypes.oneOf([300, 400, 500, 600, 700]),
    /** Applies italics if true */
    italic: PropTypes.bool,
    /** Applies a line height */
    lh: PropTypes.number,
    /** Associates a specific action onto an element for the benefit of automated clients consuming it */
    automationHook: PropTypes.string,
    /** All component children nodes */
    children: PropTypes.node,
    className: PropTypes.string,
  };

  static defaultProps = {
    italic: false,
  };

  render() {
    return (
      <span
        className={this.props.className}
        children={this.props.children}
        {...hooks.hook(this.props.automationHook)}
      />
    );
  }
}

export default styled(Text)`
  display: block;

  ${props =>
    props.size &&
    `
    font-size: ${props.theme.toRem(props.size)};
  `};

  ${props =>
    props.color &&
    `
    color: ${props.color};
  `};

  ${props =>
    props.weight &&
    `
    font-weight: ${props.weight};
  `};

  ${props =>
    props.italic &&
    `
    font-style: italic;
  `};

  ${props =>
    props.lh &&
    `
    line-height: ${props.lh};
  `};
`;
